import { useAuth } from '../contexts/AuthContext'
import Card from '../components/common/Card'

const HomePage = () => {
  const { user } = useAuth()

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold text-gray-900">Welcome, {user?.first_name}!</h2>
        <p className="text-gray-600 mt-2">Traffic Analysis Application - BOE Engineering</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Card>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Quick Stats</h3>
          <p className="text-gray-600">View your traffic analysis statistics</p>
          <div className="mt-4 text-3xl font-bold text-primary-600">0</div>
          <p className="text-sm text-gray-500">Total Reports</p>
        </Card>

        <Card>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Recent Activity</h3>
          <p className="text-gray-600">Latest traffic data analysis</p>
          <div className="mt-4 text-3xl font-bold text-primary-600">-</div>
          <p className="text-sm text-gray-500">No recent activity</p>
        </Card>

        <Card>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Account Status</h3>
          <p className="text-gray-600">Your account information</p>
          <div className="mt-4">
            <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
              Active
            </span>
          </div>
        </Card>
      </div>

      <Card>
        <h3 className="text-xl font-semibold text-gray-900 mb-4">Getting Started</h3>
        <div className="space-y-3">
          <div className="flex items-start">
            <div className="flex-shrink-0 h-6 w-6 rounded-full bg-primary-600 text-white flex items-center justify-center text-sm font-bold">
              1
            </div>
            <p className="ml-3 text-gray-700">Upload your traffic data files for analysis</p>
          </div>
          <div className="flex items-start">
            <div className="flex-shrink-0 h-6 w-6 rounded-full bg-primary-600 text-white flex items-center justify-center text-sm font-bold">
              2
            </div>
            <p className="ml-3 text-gray-700">Review the automated analysis and reports</p>
          </div>
          <div className="flex items-start">
            <div className="flex-shrink-0 h-6 w-6 rounded-full bg-primary-600 text-white flex items-center justify-center text-sm font-bold">
              3
            </div>
            <p className="ml-3 text-gray-700">Export results and share with your team</p>
          </div>
        </div>
      </Card>
    </div>
  )
}

export default HomePage
